import { Check, ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";

const CHECKLIST = [
  "Mechanical Systems",
  "Electronics & ECU",
  "Body Condition",
  "Paint Quality",
  "Accident Repairs",
  "Flood Damage",
  "Diagnostic Scanning",
];

export const About = ({ onBook }) => (
  <section
    id="about"
    data-testid="about-section"
    className="border-y border-white/10 bg-[#0a0a0a] py-28 md:py-36"
  >
    <div className="mx-auto grid max-w-7xl items-center gap-16 px-5 md:px-8 lg:grid-cols-2">
      <Reveal className="relative">
        <div className="relative">
          <div className="overflow-hidden rounded-3xl border border-white/10">
            <img
              src="https://images.pexels.com/photos/8985461/pexels-photo-8985461.jpeg?auto=compress&cs=tinysrgb&w=940"
              alt="Professional vehicle inspection"
              className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
            />
          </div>
          <div className="glass-chip gold-glow absolute -bottom-8 -right-4 rounded-2xl px-6 py-5 md:-right-8">
            <span className="block font-heading text-4xl font-extrabold tracking-tighter text-gold">
              100+
            </span>
            <span className="mt-1 block text-xs font-bold uppercase tracking-[0.2em] text-white/70">
              Vehicles Inspected
            </span>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <Chapter index="05" label="About" />
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-8 font-heading text-4xl font-extrabold tracking-tight text-white md:text-5xl">
            Meet Your Vehicle
            <span className="block text-white/40">Inspection Expert</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-7 text-base leading-relaxed text-white/60 md:text-lg">
            At Syed's Pro Drive Inspection, we help buyers make informed
            decisions before purchasing new or used vehicles. Every inspection
            follows a comprehensive checklist covering mechanical systems,
            electronics, body condition, paint quality, accident repairs, flood
            damage and diagnostic scanning.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {CHECKLIST.map((c) => (
              <span
                key={c}
                data-testid={`about-chip-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-xs font-bold text-white/70"
              >
                <Check className="h-3.5 w-3.5 text-gold" strokeWidth={3} />
                {c}
              </span>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.25}>
          <p className="mt-10 font-heading text-2xl font-extrabold tracking-tight text-gold md:text-3xl">
            "Our goal is simple: protect your investment."
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <button
            data-testid="about-book-btn"
            onClick={() => onBook()}
            className="group mt-9 flex items-center gap-3 rounded-full border border-gold/40 px-7 py-3.5 font-heading text-sm font-extrabold text-gold transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-black"
          >
            Book Your Inspection
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);
